import { Link } from "react-router-dom";

const services = [
  { title: "Pool Maintenance Services", href: "/services/pool-maintenance" },
  { title: "Pool Openings & Closings", href: "/services/pool-openings-closings" },
  { title: "Inground Pool Services", href: "/services/inground-pools" },
  { title: "Above Ground Pools", href: "/services/above-ground-pools" },
  { title: "Pool Stairs", href: "/services/pool-stairs" },
  { title: "Spa Covers", href: "/services/spa-covers" },
  { title: "Automatic Pool Cleaners", href: "/services/automatic-pool-cleaners" },
  { title: "Pool Heaters", href: "/services/pool-heaters" },
  { title: "Pool Salt Chlorine Generators", href: "/services/pool-salt-chlorine-generators" },
];

export default function Services() {
  return (
    <div className="max-w-[1400px] mx-auto px-4 py-16">
      <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">Our Services</h1>
      <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-10">
        ATLAS PRO SERVICES LLC offers a complete line of pool services to meet all your needs. From installation and maintenance to repairs and equipment upgrades, our experienced team is here to help.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {services.map((service) => (
          <Link
            key={service.href}
            to={service.href}
            className="block bg-white border border-gray-200 p-6 hover:border-[#1e2a5e] hover:shadow-md transition-all duration-300"
          >
            <h3 className="text-[#1e2a5e] font-semibold text-base">{service.title}</h3>
            <span className="text-gray-400 text-xs mt-2 inline-flex items-center gap-1">
              Learn more
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}